import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache: { counts, fetchedAt, promise }
let cache = { counts: null, fetchedAt: 0, promise: null };
const CACHE_TTL = 60 * 1000; // 1 minute
const subscribers = new Set();

async function fetchCounts(force = false) {
    const now = Date.now();
    if (!force && cache.counts && now - cache.fetchedAt < CACHE_TTL) {
        return cache.counts;
    }
    if (cache.promise) return cache.promise;
    cache.promise = axios
        .get(`${API}/share/counts`)
        .then((res) => {
            cache.counts = res.data || {};
            cache.fetchedAt = Date.now();
            cache.promise = null;
            subscribers.forEach((cb) => cb(cache.counts));
            return cache.counts;
        })
        .catch(() => {
            cache.promise = null;
            return cache.counts || {};
        });
    return cache.promise;
}

export function bumpShareCount(key, newCount) {
    if (!key) return;
    if (!cache.counts) cache.counts = {};
    cache.counts = { ...cache.counts, [key]: newCount ?? (cache.counts[key] || 0) + 1 };
    subscribers.forEach((cb) => cb(cache.counts));
}

export function useShareCount(key) {
    const [count, setCount] = useState(() => (cache.counts ? cache.counts[key] || 0 : 0));
    useEffect(() => {
        let mounted = true;
        const handler = (counts) => {
            if (mounted) setCount(counts[key] || 0);
        };
        subscribers.add(handler);
        fetchCounts().then((counts) => mounted && setCount(counts[key] || 0));
        return () => {
            mounted = false;
            subscribers.delete(handler);
        };
    }, [key]);
    return count;
}
